var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Badge',{attrs:{"color":"secondary"}},[_c('Icon',{attrs:{"icon":"project-diagram"}}),_vm._v(" "+_vm._s(_vm.processLabel)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }